export const capitalizeLetter = (value = '') => {
	return value[0]?.toUpperCase() + value.slice(1)
}
